exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-subcategory{\r\n\tpadding: 70px;\r\n    border-radius: 15px;\r\n}\r\n.input-subcategory input{\r\n    font-size: 1.5em;\r\n    color: #19b798;\r\n    padding: 25px;\r\n}\r\n.input-subcategory p{\r\n\tcolor: #fff;\r\n    font-size: 0.98em;\r\n    margin-top: 0.5em;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// d:/xampp/htdocs/zenith-admin/src/app/edit-subcategory/edit-subcategory.component.css
// module id = ../../../../../src/app/edit-subcategory/edit-subcategory.component.css
// module chunks = 1